import React from 'react';
import { 
  Formik, 
  Form, 
  Field,
  ErrorMessage} from 'formik'
import {form} from './forms.module.css'

import {
  questionSection,
  questionCount,
  questionText,
} from "../teaquiz.module.css"

const MultipleSelect = (props) => (
  <>
    <Formik
      initialValues={{
        checked: [],
        option: false,
      }}
    >
    {({values}) => (
      <Form className={form}>
        <div id="checkbox-group">{props.title}</div>
        <div className={questionSection}>
          <div className={questionCount}>
            <span>Question {props.currentQuestion + 1}</span>/{props.questions.length}
          </div>
          <div className={questionText}>{props.question}</div>
        </div>
        <div role="group" aria-labelledby="checkbox-group">
          {props.questions[props.currentQuestion].optional === true ? (
            <>
              {values.option !== true ? (
                <p>
                  This question is optional. <br />
                </p>
              ) : (
                <ul className="cboxtags">
                  {props.answersList.map((x) => (
                    <li>
                      <Field key={x.id} type="checkbox" name="checked" value={x} id={x} />
                      <label htmlFor={x}>
                        {x}
                      </label>
                    </li>
                  ))}
                </ul>
              )}

              <ul className="cboxtags">
                <li>
                  <label>
                  <Field type="checkbox" name="option" />
                    {values.option === false ? "Answer Question?" : "Disregard Question" }
                  </label>
                </li>
              </ul>
            </>
          ) : (
            <ul className="cboxtags">
              {props.answersList.map((x) => (
                <li>
                  <Field key={x.id} type="checkbox" name="checked" value={x} id={x} />
                  <label for={x}>
                    {x}
                  </label>
                </li>
              ))}
            </ul>
          )}
        </div>
        <button onClick={() => props.handlePreference(values.checked)}>Submit</button>
      </Form>
    )}
    </Formik>
    <img src={props.image} alt={props.question} />
  </>
)

export default MultipleSelect